import React from 'react';
import QualificationTable from '../components/QualificationTable';

const QualificationsPage: React.FC = () => {
  return <QualificationTable />;
};

export default QualificationsPage;
